import { useImpactPageData } from '#src/app/pages/about/impact/pageContext';
import type { ImpactPageData } from '#src/app/pages/about/impact/pageContext';

type Result = ModelHookResult<{
	featuredVictories: ImpactPageData['featuredVictories'];
}>;

export function useFeaturedVictories(): Result {
	const {
		data: { featuredVictories },
	} = useImpactPageData();

	return {
		data: { featuredVictories },
	};
}
